import Navbar from "../components/navbar";
import FooterTopImage from "../components/FoterTopImage";
import Footer from "../components/footer";
import React from "react";

export default function Login() {
    return (
        <>
            <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-left"/>
            <section className="position-relative mt-5 pt-4">
                <div className="container-fluid px-md-4 px-2 mt-2">
                    <h1>Login Page</h1>
                </div>
            </section>
            <FooterTopImage/>
            <Footer/>
        </>)
}